import { BundleLocationScreen } from '../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <BundleLocationScreen />;
}
